import React from 'react';
import { KEYBOARD_EVENTS } from '../../../../../../../utils/constants/commonConstants';
import user from '../../../../../../../assets/user.png';

/** Stays a div to keep the table's count styling, but takes button semantics so keyboard users can reach it. */
const ClickableValue = ({
    clickable,
    onClick,
    className,
    children,
}: {
    clickable: boolean;
    onClick?: () => void;
    className: string;
    children: React.ReactNode;
}) => {
    if (!clickable) return <div className={className}>{children}</div>;
    return (
        <div
            className={className}
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(event) => {
                if (event.key === KEYBOARD_EVENTS.ENTER || event.key === KEYBOARD_EVENTS.SPACE) {
                    event.preventDefault();
                    onClick?.();
                }
            }}
        >
            {children}
        </div>
    );
};

export default ClickableValue;
